import { Component } from "@angular/core";
import { ErrorMessageComponent } from "../error-message.component";


@Component({
  selector: 'app-error-message-v2',
  templateUrl: './error-message-v2.component.html',
})
export class ErrorMessageV2Component extends ErrorMessageComponent { }


@Component({
  selector: 'app-error-message-v3',
  templateUrl: './error-message-v3.component.html',
})
export class ErrorMessageV3Component extends ErrorMessageComponent { }
